<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Actualizar Sucursal"
  [style]="{ width: '800px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="field col-12 md:col-3">
            <label>Departamento</label>
            <p-dropdown
              [options]="departments"
              formControlName="departmentId"
              placeholder="Seleccionar"
              optionLabel="name"
              optionValue="id"
              [virtualScroll]="true"
              [itemSize]="11"
              (onChange)="filterProvinces($event.value)"
            >
            </p-dropdown>
            <div
              *ngIf="
                fg.get('departmentId').invalid &&
                (fg.get('departmentId').dirty || fg.get('departmentId').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('departmentId').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <label>Provincia</label>
            <p-dropdown
              [options]="provinces"
              formControlName="provinceId"
              placeholder="Seleccionar"
              optionLabel="name"
              optionValue="id"
              [virtualScroll]="true"
              [itemSize]="11"
              (onChange)="filterDistricts($event.value)"
            >
            </p-dropdown>
            <div
              *ngIf="
                fg.get('provinceId').invalid &&
                (fg.get('provinceId').dirty || fg.get('provinceId').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('provinceId').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-5">
            <label>Distrito</label>
            <p-dropdown
              [options]="districts"
              formControlName="districtId"
              placeholder="Seleccionar"
              optionLabel="name"
              optionValue="id"
              [virtualScroll]="true"
              [itemSize]="11"
            >
            </p-dropdown>
            <div
              *ngIf="
                fg.get('districtId').invalid &&
                (fg.get('districtId').dirty || fg.get('districtId').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('districtId').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Nombre</label>
            <input pInputText formControlName="name" type="text" />
            <div
              *ngIf="
                fg.get('name').invalid &&
                (fg.get('name').dirty || fg.get('name').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('name').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('name').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('name').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 255.</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Dirección</label>
            <input pInputText formControlName="address" type="text" />
            <div
              *ngIf="
                fg.get('address').invalid &&
                (fg.get('address').dirty || fg.get('address').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('address').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('address').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 5.</small
                >
              </div>
              <div *ngIf="fg.get('address').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 255.</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6">
            <label>Código de establecimiento</label>
            <input pInputText formControlName="establishmentCode" type="text" />
            <div
              *ngIf="
                fg.get('establishmentCode').invalid &&
                (fg.get('establishmentCode').dirty ||
                  fg.get('establishmentCode').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('establishmentCode').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('establishmentCode').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 2.</small
                >
              </div>
              <div *ngIf="fg.get('establishmentCode').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 32.</small
                >
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-8"></div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              (click)="onClose()"
              icon="pi pi-times"
              class="p-button-text"
              label="No"
            ></button>
          </div>
          <div class="field col-12 md:col-2">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              class="p-button-text"
              icon="pi pi-check"
              [disabled]="fg.invalid"
              label="Si"
            ></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
